// extracted by mini-css-extract-plugin
module.exports = {"root":"SortableItem_root__2rtUB","dragIcon":"SortableItem_dragIcon__2-DdN","disabled":"SortableItem_disabled__3KKlT"};